import { FC } from 'react';
import { useDispatch } from 'react-redux';
import { useAuth } from 'features/auth/hooks/useAuth';
import { logout } from 'features/auth/authenticationSlice';
import { queryApi } from 'app/apis/queryApi';
import { clearSites } from 'features/topbar/selectedSiteSlice';
import { persistor } from 'app/store';
import { authApi } from 'app/apis/authApi';

const LogoutButton: FC<{ buttonClasses: string; buttonLabel: string }> = ({
  buttonClasses,
  buttonLabel
}) => {
  const dispatch = useDispatch();
  const { isAuthenticated } = useAuth();

  const logoutButton = () => {
    if (!isAuthenticated) {
      return;
    }

    return (
      <button
        onClick={() => {
          dispatch(logout());
          dispatch(clearSites());
          dispatch(queryApi.util.resetApiState());
          dispatch(authApi.util.resetApiState());
          persistor
            .purge()
            .then(() => {
              console.log('purged app state');
            })
            .catch(() => {
              console.log('app state purge failed');
            });
        }}
        className={`${buttonClasses}`}
      >
        <span className="flex items-center">
          <i className="ra-icons-generic-export-1 text-neutral-500 flex mr-2 rotate-90"></i>
          <span className="leading-4">{buttonLabel}</span>
        </span>
      </button>
    );
  };

  return <>{logoutButton()}</>;
};

export default LogoutButton;
